// extracted by mini-css-extract-plugin
module.exports = {"RoomsTitle":"rooms_RoomsTitle__1fVi0","RoomsSubTtile":"rooms_RoomsSubTtile__3XafO","imgContainer":"rooms_imgContainer__VZQI0"};